import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Twitter } from "../../basic/icons/twitter";
import { ShareIcon } from "../../basic/icons/share-icon";
import { CloseIcon } from "../../basic/icons/close-icon";
import { Facebook } from "../../basic/icons/facebook";
import { Whatsapp } from "../../basic/icons/whatsapp";

import "./styles.m.css";

class StickySocialShareTemplateBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.toggleClass = this.toggleClass.bind(this);
  }
  toggleClass() {
    const currentState = this.state.open;
    this.setState({ open: !currentState });
  }
  render() {
    const styleName = this.props.publisherAttributes.lang === "ur" ? "urdu-social-share" : "social-share";
    return (
      <div styleName="sticky-social-share">
        <ul styleName={styleName} className={this.state.open ? "open" : null}>
          <li styleName="social-share-icon">
            <span onClick={this.toggleClass} styleName="social-share-link shareIcon-bg" className="  close-icon">
              {this.state.open ? <CloseIcon color="#1C1C1C" /> : <ShareIcon color={this.props.color} />}
            </span>
          </li>
          <li styleName="social-share-icon">
            <a
              styleName="social-share-link twitter-bg"
              href={this.props.twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter color={this.props.color} />
            </a>
          </li>
          <li styleName="social-share-icon">
            <a
              styleName="social-share-link facebook-bg"
              href={this.props.fbUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook color={this.props.color} />
            </a>
          </li>
          <li styleName="social-share-icon">
            <a
              styleName="social-share-link whatsapp-bg"
              href={this.props.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Whatsapp color={this.props.color} />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
StickySocialShareTemplateBase.propTypes = {
  color: PropTypes.string,
  twitterUrl: PropTypes.string,
  fbUrl: PropTypes.string,
  gplusUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  publisherAttributes: PropTypes.object
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const StickySocialShareTemplate = connect(
  mapStateToProps,
  null
)(StickySocialShareTemplateBase);
